import { NgModule } from '@angular/core';
import { mapToCanActivateChild, PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AppGuard } from './app.guard';
import { NavigationTabs } from 'src/app/shared/navigation-tabs';
import { RequireAuthenticatedGuard } from 'src/app/core/require-authenticated-guard';
import { warehouseAccessGuard } from 'src/app/core/warehouse-access.guard';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },
  {
    path: 'locked-out',
    loadChildren: () => import('./pages/locked-out/locked-out.module').then(m => m.LockedOutPageModule),
  },
  {
    path: 'job-complete',
    loadChildren: () => import('./pages/job-complete/job-complete.module').then(m => m.JobCompletePageModule)
  },
  {
    path: 'job-detail',
    loadChildren: () => import('./pages/job-detail/job-detail.module').then(m => m.JobDetailPageModule),
    canActivate: [AppGuard],
  },
  {
    path: 'payment',
    loadChildren: () => import('./pages/payment/payment.module').then(m => m.PaymentModule),
    canActivate: [AppGuard],
  },
  {
    path: 'valuations',
    loadChildren: () => import('./pages/valuations/valuations.module').then(m => m.ValuationsModule),
    canActivate: [AppGuard],
  },
  {
    path: NavigationTabs.Settings,
    canActivateChild: mapToCanActivateChild([RequireAuthenticatedGuard]),
    loadChildren: () => import('./pages/settings/settings.module').then(m => m.SettingsModule),
  },
  {
    path: NavigationTabs.ScheduleView,
    loadChildren: () => import('./pages/schedule-view/schedule-view.module').then(m => m.ScheduleViewPageModule),
    canActivate: [AppGuard],
  },
  {
    path: NavigationTabs.JobHistory,
    loadChildren: () => import('./pages/job-history/job-history.module').then(m => m.JobHistoryPageModule),
    canActivate: [AppGuard],
  },
  {
    path: NavigationTabs.Warehouse,
    loadChildren: () => import('./pages/warehouse/warehouse.module').then(m => m.WarehouseModule),
    // AppGuard handles auth + datastore init; warehouseAccessGuard enforces the same
    // toggle + permission predicate as the tab button, protecting direct-URL entry.
    canActivate: [AppGuard, warehouseAccessGuard],
  },
  // Public-facing pages
  {
    path: '',
    loadChildren: () => import('./pages/login/login.module').then(m => m.LoginPageModule)
  },
  { path: '**', redirectTo: '/' + NavigationTabs.ScheduleView },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      enableTracing: false, // useful for debugging route issues
      preloadingStrategy: PreloadAllModules,
      useHash: true,
      paramsInheritanceStrategy: "always"
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
